import React from 'react';

const skills = [
  { category: "Languages",    items: "HTML, CSS, JavaScript, PHP, Python, Liquid" },
  { category: "Frameworks",   items: "React, SCSS, Smarty, Tailwind, Material UI, Bootstrap, REST APIs" },
  { category: "Tools",        items: "Git, Figma, VS Code, Sublime, Adobe Suite" },
  { category: "Performance",  items: "Google Analytics, SEO, Web Accessibility, Search Console, Responsive/Mobile-First Design" },
  { category: "CMS",          items: "Webflow, WordPress, Drupal, Squarespace, Shopify, Wix, HubSpot CMS" },
  { category: "Marketing &\nWeb Admin", items: "Google Tag Manager, Mailchimp, HubSpot, Constant Contact, WP Umbrella, GoDaddy, Bluehost, SiteGround, WP Engine, cPanel, Cloudflare" },
];

const Skills = () => (
  <section id="skills" style={{ padding: "20px 24px 40px" }}>
    <div style={{ maxWidth: "1100px", margin: "0 auto" }}>
      <h2 className="text-4xl font-bold text-center text-pink-400" style={{ marginBottom: "30px" }}>Skills</h2>
      <div style={{ maxWidth: "700px", margin: "0 auto" }}>
        {skills.map((row, i) => (
          <div
            key={i}
            className="skills-row"
            style={{
              padding: "18px 0",
              borderBottom: i < skills.length - 1 ? "1px solid rgba(124,58,237,0.15)" : "none",
            }}
          >
            <span style={{
              color: "#a78bfa",
              fontWeight: 600,
              fontSize: "0.8rem",
              letterSpacing: "0.08em",
              textTransform: "uppercase",
            }}>
              {row.category.split("\n").map((line, idx, arr) => (
                <React.Fragment key={idx}>
                  {line}
                  {idx < arr.length - 1 && <br />}
                </React.Fragment>
              ))}
            </span>
            <span style={{
              color: "#ffffff",
              fontSize: "0.9rem",
              lineHeight: 1.6,
            }}>
              {row.items}
            </span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Skills;
